<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Gestão Cadastros"
            description="Situação dos cadastros na APS"
            url="/dashboard"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <div
            class="item"
            role="button"
            tabindex="0"
            @click.prevent="onCardClick(item)"
          >
            <i v-if="item.icone !== false" :class="item.icone"></i>
            <img v-else :src="item.imagem" alt="" />
            <h3>{{ item.titulo }}</h3>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  name: 'GestaoCadastros',
  metaInfo: {
    title: 'Gestão Cadastros',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  computed: {
    cards() {
      return this.$store.state?.permissoes?.gestao_cadastros
    },
  },
  data() {
    return {}
  },
  methods: {
    onCardClick(item) {
      if (typeof item.callback === 'function') {
        // Passa o contexto Vue e o helper de navegação
        item.callback(this, this.navigateTo)
      } else {
        this.navigateTo(item.link, item.openNewTab)
      }
    },

    navigateTo(link, openNewTab) {
      const { href } = this.$router.resolve(link)
      if (openNewTab) {
        window.open(href, '_blank')
      } else {
        this.$router.push(link)
      }
    },
  },
}
</script>

<style></style>
